import React, { Component } from "react";
import { render } from "react-dom";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { ValueTypeEnum, ButtonMessageEnum } from "../../../enums";
import { Form, Field } from "react-final-form";
import { Button } from "@progress/kendo-react-buttons";
import { LocalizationService } from "@progress/kendo-react-intl";
import { logController } from "../../../controllers/log.controller";

let resolve;

export class VyberPoziceGlsStitkyDialog extends Component {
    static create(props = {}) {
        const containerElement = document.createElement("div");
        document.body.appendChild(containerElement);
        return render(<VyberPoziceGlsStitkyDialog createPromptProps={props} />, containerElement);
    }

    constructor() {
        super();

        this.state = {
            isOpen: false,
            selectedPoziceStitku: 1,
            showPromptProps: {}
        };

        this.handleCancel = this.handleCancel.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.show = this.show.bind(this);
    }

    handleCancel() {
        this.setState({ isOpen: false });
        if (this.state.showPromptProps.logMessage == true) {
            logController.logMessage(`${this.state.showPromptProps.message} => ${ButtonMessageEnum.CANCEL}`);
        }
        resolve({ button: ButtonMessageEnum.CANCEL });
    }

    selectPoziceStitku(pozice) {
        this.setState({ selectedPoziceStitku: pozice });

        document.getElementById("pozice-stitku-1").classList.remove("pozice-selected");
        document.getElementById("pozice-stitku-2").classList.remove("pozice-selected");
        document.getElementById("pozice-stitku-3").classList.remove("pozice-selected");
        document.getElementById("pozice-stitku-4").classList.remove("pozice-selected");

        document.getElementById("pozice-stitku-" + pozice).classList.add("pozice-selected");
    }

    handleOnSubmit(values) {
        this.setState({ isOpen: false });
        if (this.state.showPromptProps.logMessage == true) {
            logController.logMessage(`${this.state.showPromptProps.message} => ${ButtonMessageEnum.OK} (${this.state.selectedPoziceStitku})`);
        }
        resolve({ button: ButtonMessageEnum.OK, value: this.state.selectedPoziceStitku });
    }

    show(props = {}) {
        const showPromptProps = { ...this.props.createPromptProps, ...props };
        this.setState({ isOpen: true, selectedPoziceStitku: 1 , showPromptProps: showPromptProps });

        var autoFocus = document.getElementById("VyberPoziceGlsStitkyDialogForm");
        if (autoFocus) {
            autoFocus = autoFocus.getElementsByTagName("input")[0];
            if (autoFocus) {
                autoFocus.focus();
            }
        }

        return new Promise((res) => {
            resolve = res;
        });
    }

    render() {
        var selectedLanguage = localStorage.getItem("selectedLanguage");
        var localizationService = new LocalizationService(selectedLanguage);

        const defaultProps = {
            title: localizationService.toLanguageString("VyberPoziceGlsStitkyDialog.Vyberte pozíciu", "Vyberte pozíciu"),
            message: localizationService.toLanguageString(
                "VyberPoziceGlsStitkyDialog.Vyberte pozíciu prvého štítku na stránke a vložte do tlačiarne papier so štítkami (A4_2x2)",
                "Vyberte pozíciu prvého štítku na stránke a vložte do tlačiarne papier so štítkami (A4_2x2)"
            )
        };

        const { isOpen, showPromptProps } = this.state;
        const { message, title, ...rest } = showPromptProps;

        return isOpen ? (
            <div id="VyberPoziceGlsStitkyDialogForm">
                <Dialog title={title || defaultProps.title} onClose={this.handleCancel}>
                    <Form
                        onSubmit={(values) => this.handleOnSubmit(values)}
                        render={({ form, handleSubmit, submitting }) => (
                            <React.Fragment>
                                <form onSubmit={handleSubmit} className="k-form">
                                    <fieldset>
                                        <div className="col-xs-6 vyber-pozice-text">
                                            <div className="text-center">{message || defaultProps.message}</div>
                                        </div>
                                        <div className="col-xs-6">
                                            <div className="pozice-stitku k-dialog-buttongroup k-dialog-button-layout-stretched">
                                                <Button
                                                    id="pozice-stitku-1"
                                                    className="font-bold pozice-selected"
                                                    type="button"
                                                    onClick={() => this.selectPoziceStitku(1)}>
                                                    1
                                                </Button>
                                                <Button id="pozice-stitku-2" className="font-bold" type="button" onClick={() => this.selectPoziceStitku(2)}>
                                                    2
                                                </Button>
                                                <Button id="pozice-stitku-3" className="font-bold" type="button" onClick={() => this.selectPoziceStitku(3)}>
                                                    3
                                                </Button>
                                                <Button id="pozice-stitku-4" className="font-bold" type="button" onClick={() => this.selectPoziceStitku(4)}>
                                                    4
                                                </Button>
                                            </div>
                                        </div>
                                    </fieldset>
                                </form>
                                <DialogActionsBar>
                                    <Button icon="check" className="font-bold" primary={true} type="submit" onClick={handleSubmit} disabled={submitting}>
                                        OK
                                    </Button>
                                    <Button className="font-bold" onClick={this.handleCancel}>
                                        Zrušit
                                    </Button>
                                </DialogActionsBar>
                            </React.Fragment>
                        )}
                    />
                </Dialog>
            </div>
        ) : (
            <React.Fragment />
        );
    }
}

export default VyberPoziceGlsStitkyDialog;



// WEBPACK FOOTER //
// ./src/components/common/vyberPoziceGlsStitkyService/VyberPoziceGlsStitkyDialog.js